import { render, staticRenderFns } from "./AnnotationCard.vue?vue&type=template&id=33ba4352&scoped=true&"
import script from "./AnnotationCard.vue?vue&type=script&lang=js&"
export * from "./AnnotationCard.vue?vue&type=script&lang=js&"
import style0 from "./AnnotationCard.vue?vue&type=style&index=0&id=33ba4352&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ba4352",
  null
  
)

export default component.exports